import USPS_THOROUGHFARE_SUFFIXES from './usps-street-suffixes-and-names.json';

const LA_QUINTA_STREET_ABBREV_HACKS = ['GEORGE'];
const THOROUGHFARE_NAME_SET = new Set([
  ...USPS_THOROUGHFARE_SUFFIXES,
  ...LA_QUINTA_STREET_ABBREV_HACKS,
]);

export function parseComponentsFromAddress(addressString) {
  const sanitizedAddress = addressString
    .replaceAll(',', '')
    .replaceAll(/ +/g, ' ')
    .trim();

  const tokens = sanitizedAddress.split(' ');

  if (!tokens.length) return {};

  const zip = tokens[tokens.length - 1];
  const state = tokens[tokens.length - 2];

  const streetAndCityTokens = tokens.slice(0, tokens.length - 2);
  const streetAndCityTokensUpperCase = streetAndCityTokens.map((s) =>
    s.toUpperCase()
  );

  if (!streetAndCityTokens.length) return { state, zip };

  let foundThoroughfareTokenIndex = -1;

  for (let i = streetAndCityTokensUpperCase.length; i >= 0; i--) {
    if (THOROUGHFARE_NAME_SET.has(streetAndCityTokensUpperCase[i])) {
      foundThoroughfareTokenIndex = i;
      break;
    }
  }

  if (foundThoroughfareTokenIndex < 0) return { state, zip };

  const street = streetAndCityTokens
    .slice(0, foundThoroughfareTokenIndex + 1)
    .join(' ');
  const city = streetAndCityTokens
    .slice(foundThoroughfareTokenIndex + 1)
    .join(' ');

  return { street, city, state, zip, __success: true };
}

export function parseComponentsFromAddressSafe(addressString) {
  try {
    return parseComponentsFromAddress(addressString);
  } catch (e) {
    console.error(e);
    return {};
  }
}
